import { latin1Bytes } from '@/lib/referral/referralReceipt';

function downloadLatin1(text: string, filename: string, mimeType: string): void {
  const source = latin1Bytes(text);
  const buffer = new ArrayBuffer(source.byteLength);
  new Uint8Array(buffer).set(source);
  const blob = new Blob([buffer], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}

/** Download XML as the Latin-1 bytes already in the string. The browser must not re-encode them as UTF-8. */
export function downloadLatin1Xml(xml: string, filename: string): void {
  downloadLatin1(xml, filename, 'application/xml');
}

/** Download EDIFACT (REF06) as the Latin-1 bytes already in the string. */
export function downloadLatin1Edifact(edi: string, filename: string): void {
  downloadLatin1(edi, filename, 'text/plain');
}
